import {
  Card,
  Checkbox,
  Dropdown,
  FloatButton,
  Pagination,
  Tooltip,
} from "antd";
import React, { useState } from "react";
import {
  DownOutlined,
  PlusOutlined,
  DownSquareOutlined,
  BellOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { formateDate } from "src/components/helpers/formateDate";
import {
  getAbonementsClient,
  getClientTrainings,
  getClientsList,
  commentsAction,
  getTransactions,
  getLink,
} from "src/store/Slices/ClientsSlice";

const MobileClientsNew = ({
  clientsList,
  clientsListLoading,
  setIsOpenAddEditModal,
  setClientInfo,
  setIsOpenDeleteModal,
  page,
  setPage,
  pageSize,
  setPageSize,
  setTab,
  setTabPage,
  allActive,
  setAllActive,
  mnemo,
  setClientMarkedList,
  setIsOpenAddMailModal,
}) => {
  const dispatch = useDispatch();
  const [checkers, setCheckers] = useState(false);
  const [markedClients, setMarkedClients] = useState([]);
  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenAddEditModal({ open: true, flag: "edit" });
      },
      disabled: !mnemo?.children
        ?.find((el) => el.name === "Таблица клиентов")
        ?.children.find((ele) => ele.mnemo === "updateBtn"),
    },
  ];
  let arr = [];
  const pushInClientArr = (record) => {
    //
    const isSelected = markedClients.includes(record.id);
    if (isSelected) {
      arr = markedClients.filter((clientId) => clientId !== record.id);
      setMarkedClients(arr);
      setClientMarkedList(arr);
    } else {
      arr = [...markedClients, record.id];
      setMarkedClients(arr);
      setClientMarkedList(arr);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Pagination
          defaultCurrent={page}
          pageSize={20}
          showSizeChanger={false}
          current={page}
          onChange={(page, pageSize) => {
            dispatch(
              getClientsList({
                count: pageSize,
                offset: pageSize * (page - 1),
              })
            );
            setPage(page);
            setPageSize(pageSize);
          }}
          total={clientsList?.data?.value?.totalCount}
          page={page}
        />
        {clientsList?.data?.value?.rows.map((element) => {
          return (
            <Card
              loading={clientsListLoading}
              title={`Клиент №: ${element.id}`}
              extra={
                <>
                  <Dropdown
                    menu={{
                      items,
                    }}
                  >
                    <a
                      onClick={() => {
                        setClientInfo({
                          ...element,
                          birthday:
                            element?.birthday && formateDate(element?.birthday),
                        });
                      }}
                      className="text-primary text-decoration-none"
                    >
                      Действия <DownOutlined />
                    </a>
                  </Dropdown>
                  {checkers && (
                    <Checkbox
                      // onClick={e => e.stopPropagation()}
                      onChange={() => pushInClientArr(element)}
                      checked={markedClients.includes(element.id)}
                    ></Checkbox>
                  )}
                </>
              }
              style={{ width: 330, marginTop: 16 }}
              key={element.id}
              actions={[
                <div
                  onClick={() => {
                    setTab("Абонементы");
                    setTabPage("Абонементы");
                    setClientInfo({
                      ...element,
                      birthday:
                        element?.birthday && formateDate(element?.birthday),
                    });
                    dispatch(getAbonementsClient({ clientId: element.id }));
                  }}
                >
                  Абонементы
                </div>,
                <div
                  onClick={() => {
                    setTab("Тренировки");
                    setTabPage("Тренировки");
                    setClientInfo({
                      ...element,
                      birthday:
                        element?.birthday && formateDate(element?.birthday),
                    });
                    dispatch(getClientTrainings({ clientId: element.id }));
                  }}
                >
                  Тренировки
                </div>,
                <div
                  onClick={() => {
                    setTab("Комментарии");
                    setTabPage("Комментарии");
                    setClientInfo({
                      ...element,
                      birthday:
                        element?.birthday && formateDate(element?.birthday),
                    });
                    dispatch(
                      commentsAction({
                        flag: "get",
                        value: { UserId: element.id },
                      })
                    );
                  }}
                >
                  Комментарии
                </div>,
                <div>
                  <div
                    onClick={() => {
                      setTab("Ссылки на оплату");
                      setTabPage("Ссылки на оплату");
                      setClientInfo({
                        ...element,
                        birthday:
                          element?.birthday && formateDate(element?.birthday),
                      });
                      dispatch(
                        getLink({
                          flag: "get",
                          value: { UserId: element.id },
                        })
                      );
                    }}
                  >
                    Оплата
                  </div>
                  ,
                  <div
                    onClick={() => {
                      setTab("Транзакции");
                      setTabPage("Транзакции");
                      setClientInfo({
                        ...element,
                        birthday:
                          element?.birthday && formateDate(element?.birthday),
                      });
                      dispatch(getTransactions({ UserId: element.id }));
                    }}
                  >
                    Транзакции
                  </div>
                </div>,
              ]}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <div>№:</div>
                  <div>Номер телефона:</div>
                  <div>Почта:</div>
                  <div>Фамилия:</div>
                  <div>Имя:</div>
                  <div>Отчество:</div>
                  <div>Дата рождения:</div>
                  <div>Клуб:</div>
                  <div>Дата контакта:</div>
                  <div>Комментарий:</div>
                  <div>Задача:</div>
                  <div>Дата последней покупки:</div>
                </div>
                <div>
                  <div>{element?.id ? element?.id : "-"}</div>
                  <div>
                    {element?.phoneNumber ? (
                      <Tooltip title={element?.phoneNumber}>
                        {element?.phoneNumber.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.eMail ? (
                      <Tooltip title={element?.eMail}>
                        {element?.eMail.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.clientF ? (
                      <Tooltip title={element?.clientF}>
                        {element?.clientF.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.clientI ? (
                      <Tooltip title={element?.clientI}>
                        {element?.clientI.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.clientO ? (
                      <Tooltip title={element?.clientO}>
                        {element?.clientO.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.birthday ? (
                      <Tooltip title={element?.birthday}>
                        {formateDate(element?.birthday)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.club ? (
                      <Tooltip title={element?.club}>
                        {element?.club.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.contactDate ? (
                      <Tooltip title={formateDate(element?.contactDate)}>
                        {formateDate(element?.contactDate)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.comment ? (
                      <Tooltip title={element?.comment}>
                        {element?.comment.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.task ? (
                      <Tooltip title={element?.task}>
                        {element?.task.slice(0, 15)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {element?.lastAbonementBuyDate ? (
                      <Tooltip
                        title={formateDate(element?.lastAbonementBuyDate)}
                      >
                        {formateDate(element?.lastAbonementBuyDate)}
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </div>
            </Card>
          );
        })}
        <FloatButton
          style={{ right: 24 }}
          type="primary"
          icon={<PlusOutlined />}
          disabled={
            !mnemo?.children
              ?.find((el) => el.name === "Таблица клиентов")
              ?.children.find((ele) => ele.mnemo === "insertBtn")
          }
          onClick={() => {
            setIsOpenAddEditModal({ open: true, flag: "add" });
          }}
        />
        <FloatButton
          style={{ right: 68 }}
          type="primary"
          icon={<DownSquareOutlined />}
          disabled={
            !mnemo?.children
              ?.find((el) => el.name === "Таблица клиентов")
              ?.children.find((ele) => ele.mnemo === "insertBtn")
          }
          onClick={() => {
            setCheckers(!checkers);
          }}
        />
        <FloatButton
          style={{ left: 24 }}
          type="primary"
          icon={<BellOutlined />}
          disabled={
            !mnemo?.children
              ?.find((el) => el.name === "Таблица клиентов")
              ?.children.find((ele) => ele.mnemo === "insertBtn")
          }
          onClick={() => {
            setIsOpenAddMailModal({ open: true });
          }}
        />
      </div>
    </>
  );
};

export default MobileClientsNew;
